import React, { useState } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
// import ErrorBoundary from './components/ErrorBoundary'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { BASEDIR } from './constants'
import App from './App'
import 'style/fonts.css'
import { fontList } from 'constants'
import { grey } from '@mui/material/colors'

import Araboard from './pages/araboard'
import Settings from './pages/settings'
import Pictogram from './pages/pictogram'

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
})

const NotFound = () => <h1>No hemos encontrado esta página.</h1>

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <App />,
      // loader: rootLoader,
      children: [
        {
          index: true,
          element: <Araboard />,
          // loader: teamLoader,
        },

        {
          path: 'settings',
          element: <Settings />,
          // loader: teamLoader,
        },
        {
          path: 'pictograms/:uuid',
          element: <Pictogram />,
          // loader: teamLoader,
        },
      ],
    },
    {
      path: '*', // Wildcard for 404 Not Found
      element: <NotFound />, // Custom 404 component
    },
  ],
  {
    basename: BASEDIR,
  }
)

const colors = {
  primary: '#8bc34a',
}

function Root() {
  const [mode, setMode] = useState('light')
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () =>
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light')),
    }),
    [setMode]
  )
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: colors.primary, // Custom primary color
            // light: '#63a4ff', // Optional light shade
            // dark: '#004ba0',  // Optional dark shade
            contrastText: '#ffffff', // Optional text color
          },
          secondary: {
            main: grey[600], // Set secondary color to grey 600
          },
        },
        typography: {
          h1: {
            fontSize: '2.5rem', // Change size for h1
            fontWeight: 400, // You can also change weight
          },
          h2: {
            fontSize: '2rem', // Change size for h2
            fontWeight: 300,
          },
          h3: {
            fontSize: '1.75rem', // Change size for h3
            fontWeight: 300,
          },
          h4: {
            fontSize: '1.30rem', // Change size for h3
            fontWeight: 300,
          },
          fontFamily: fontList.join(','),
        },
        components: {
          MuiAppBar: {
            styleOverrides: {
              colorPrimary: {
                backgroundColor: colors.primary,
              },
            },
          },
        },
      }),
    [mode]
  )
  return (
    <ThemeProvider theme={theme}>
      <ColorModeContext.Provider value={colorMode}>
        {/* <ErrorBoundary> */}
        <RouterProvider router={router} />
        {/* </ErrorBoundary> */}
      </ColorModeContext.Provider>
      <CssBaseline />
    </ThemeProvider>
  )
}

export default Root
